import type { Follow } from 'types/following';

const asResultCodeMap = (follows: Follow[]): Record<string, Follow> =>
  follows.reduce(
    (acc, follow) => {
      acc[follow.resultCode] = follow;
      return acc;
    },
    {} as Record<string, Follow>
  );

export default asResultCodeMap;
